import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-466be5ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewHeader" }
const _hoisted_2 = {
  class: "relative",
  ref: "searchref"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_4 = { class: "flex items-center w-full" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_6 = {
  class: "relative",
  ref: "elementref"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_header_search_suggestions = _resolveComponent("header-search-suggestions")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_header_profile = _resolveComponent("header-profile")!
  const _component_header_profile_dropdown = _resolveComponent("header-profile-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_input, {
        placeholder: "Поиск накладной",
        value: _ctx.search_state.query,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_state.query) = $event)),
        disabled: _ctx.search_state.is_loading,
        "is-invalid": _ctx.search_state.is_failed,
        onInput: _ctx.searchSuggestions
      }, {
        "icon-left": _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["value", "disabled", "is-invalid", "onInput"]),
      _withDirectives(_createVNode(_component_header_search_suggestions, {
        loading: _ctx.search_state.is_loading,
        failed: _ctx.search_state.is_failed,
        suggestions: _ctx.search_state.suggestions
      }, null, 8, ["loading", "failed", "suggestions"]), [
        [_vShow, Boolean(_ctx.search_state.query)]
      ])
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isSectorsVisible && !_ctx.withoutSectors)
        ? (_openBlock(), _createBlock(_component_new_select, {
            key: 0,
            class: "w-full",
            "nullable-option": _ctx.isNullableOption,
            "nullable-text": "Все секторы",
            "custom-option": _ctx.isCustomOption,
            "custom-value": 999999,
            "is-custom-checked": _ctx.state.is_custom_checked,
            "custom-text": "Без сектора",
            value: _ctx.new_dispatcher_store.dispatcherSectorId,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.new_dispatcher_store.dispatcherSectorId) = $event)),
            placeholder: "Сектор диспетчера",
            loading: _ctx.data_state.dispatcher_sectors.is_loading,
            failed: _ctx.data_state.dispatcher_sectors.is_failed,
            "error-text": "Произошла ошибка",
            options: _ctx.data_state.dispatcher_sectors.list,
            "search-without-refresh": "",
            "is-invalid": 
                    _ctx.new_dispatcher_store.validation$.dispatcherSectorId.$error && !_ctx.isNullableOption
                ,
            onRefresh: _ctx.loadDispatcherSectors,
            onChange: _ctx.onDispatcherSectorChange,
            onSelectCustom: _ctx.onSelectCustom
          }, null, 8, ["nullable-option", "custom-option", "is-custom-checked", "value", "loading", "failed", "options", "is-invalid", "onRefresh", "onChange", "onSelectCustom"]))
        : _createCommentVNode("", true),
      (_ctx.isSectorsVisible && !_ctx.withoutSectors)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            disabled: _ctx.state.is_loading,
            class: "NewButton--reset ml-2",
            onClick: _ctx.onDispatcherSectorChange
          }, {
            "icon-left": _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_header_profile, { onClick: _ctx.toggleHeaderDropdown }, null, 8, ["onClick"]),
      (_ctx.state.is_header_dropdown_opened)
        ? (_openBlock(), _createBlock(_component_header_profile_dropdown, { key: 0 }))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}